module.exports = __webpack_public_path__ + "static/media/Voluntier Network.5324e278.png";